import { InvalidateQueryFilters, useQueryClient } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { LocationType } from 'types/Location'

interface UseSecondStepProps {
    initialEventLocationId?: string
    initialLocationId?: string
    onNext: (data: Record<string, any>) => void
    onPrevious: () => void
    eventData: Record<string, any>
}

export const useSecondStep = ({ initialEventLocationId, initialLocationId, onNext, onPrevious, eventData }: UseSecondStepProps) => {
    const [mode, setMode] = useState<'select' | 'create'>('select')
    const [selectedRow, setSelectedRow] = useState<LocationType | null>(null)
    const queryClient = useQueryClient()

    useEffect(() => {
        if (initialEventLocationId) {
            setSelectedRow({ event_location_id: initialEventLocationId } as LocationType)
        } else if (initialLocationId) {
            setSelectedRow({ location_id: initialLocationId } as LocationType)
        }
    }, [initialEventLocationId, initialLocationId])

    const onModeChange = (newMode: 'select' | 'create') => {
        setMode(newMode)
    }

    const handleNext = () => {
        if (selectedRow) {
            if (selectedRow.event_location_id) onNext({ event_location_id: selectedRow.event_location_id })
            else if (selectedRow.location_id) onNext({ location_id: selectedRow.location_id })
        }
    }

    const handleShowCreationSuccess = (event_location_id?: string) => {
        setMode('select')

        const previous = selectedRow

        queryClient.invalidateQueries(['locations'] as InvalidateQueryFilters)
        queryClient.invalidateQueries(['event_locations'] as InvalidateQueryFilters)
        queryClient.invalidateQueries(['event_locations', eventData.event_id] as InvalidateQueryFilters)

        // Invalidate the specific event_location query that step 3 will use
        if (event_location_id) {
            queryClient.invalidateQueries(['event-location', event_location_id] as InvalidateQueryFilters)
        }

        if (previous !== null) {
            setSelectedRow(previous)
        }
    }

    return {
        mode,
        selectedRow,
        setSelectedRow,
        onModeChange,
        handleNext,
        handleShowCreationSuccess,
        onPrevious,
        eventData,
    }
}
